import React from 'react';
import { Controller, UseFormReturn, FieldError, PathValue, Path } from 'react-hook-form';
import { useContent, useContentContext } from '@qbe/dfc-content';
import { TextField } from '@qbe/ads-core';
import { CamelCase } from 'type-fest';
import { camelCase } from 'lodash';
import FormSpacer from 'components/FormSpacer/FormSpacer';
import { FormDataType } from 'contexts/FormProvider';

type Prefix = 'rep';

interface Props {
  prefix?: 'rep' | '';
  form: UseFormReturn<FormDataType>;
}

type MName = CamelCase<`${Prefix | ''} m Phone Number`>;
type HName = CamelCase<`${Prefix | ''} h Phone Number`>;
type OName = CamelCase<`${Prefix | ''} o Phone Number`>;
type OneValidName = CamelCase<`Have One Valid ${Prefix | ''} Number`>;
type ContactNumberFormData = Record<MName | HName | OName | OneValidName, string | null>;

export default function ContactNumber({ form, prefix = '' }: Props) {
  const {
    register,
    formState: { errors },
    control,
  } = form as unknown as UseFormReturn<ContactNumberFormData>;
  const { getTextContent } = useContent({ context: useContentContext() });

  // Localized content constants
  const mobileLabel = getTextContent('contactNumber.mobile');
  const homeLabel = getTextContent('contactNumber.home');
  const otherLabel = getTextContent('contactNumber.other');

  const mName = camelCase(`${prefix} m Phone Number`) as MName;
  const hName = camelCase(`${prefix} h Phone Number`) as HName;
  const oName = camelCase(`${prefix} o Phone Number`) as OName;
  const oneValidName = camelCase(`Have One Valid ${prefix} Number`) as OneValidName;

  return (
    <>
      <>
        <Controller
          name={mName}
          control={control}
          defaultValue={''}
          render={({ field }) => (
            <TextField
              {...field}
              error={!!errors[mName]}
              label={mobileLabel}
              value={field.value as string}
              id={mName}
              data-track={mName}
              data-track-value="mask"
              inputProps={{
                maxLength: 20,
              }}
              helperText={errors[mName] ? (errors[mName] as FieldError)?.message : null}
            />
          )}
        />
        <FormSpacer type="input" />

        <input style={{ display: 'none' }} type="checkbox" {...register(oneValidName)} />
        <Controller
          name={hName}
          control={control}
          defaultValue={''}
          render={({ field }) => (
            <TextField
              {...field}
              error={!!errors[hName]}
              label={homeLabel}
              id={hName}
              value={field.value as string}
              data-track={hName}
              data-track-value="mask"
              inputProps={{
                maxLength: 20,
              }}
              helperText={errors[hName] ? (errors[hName] as FieldError)?.message : null}
            />
          )}
        />

        <FormSpacer type="input" />
        <Controller
          control={control}
          name={oName}
          defaultValue={''}
          render={({ field }) => (
            <TextField
              {...field}
              error={!!errors[oName]}
              label={otherLabel}
              id={oName}
              value={field.value as string}
              data-track={oName}
              data-track-value="mask"
              inputProps={{
                maxLength: 20,
              }}
              helperText={errors[oName] ? (errors[oName] as FieldError)?.message : null}
            />
          )}
        />
      </>
    </>
  );
}
